import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/Rihal_logo-fullcolor-rgb.svg';
import { RiUserAddLine } from "react-icons/ri";
import { FaBuilding } from "react-icons/fa6";

const SignUpChoicePage = () => {
  return (
    <div className="relative min-h-screen flex justify-center items-center bg-gradient-to-t from-green-400 to-green-100">
      <img
        src={logo}
        alt="logo"
        className="bg-transparent blur-sm w-full h-full absolute p-40"
      />
      <div className="backdrop-blur-md absolute rounded-3xl shadow-lg w-full max-w-4xl h-max z-20 p-48">
        <h2 className="text-4xl font-bold text-center mb-6">انشاء حساب</h2>
        <p className="text-2xl font-semibold text-center mb-20">اختر صفتك لانشاء حساب</p>
        <div className="flex flex-row justify-center items-center">
          {/* Link to Tourist SignUp */}
          <Link
            to="/TouristSignUpPage" // Change to the path for tourist signup
            className="border-2 border-green-100 text-white text-center mx-4 text-4xl px-8 py-6 rounded-md flex flex-col justify-center items-center hover:bg-green-100 hover:text-green-600 transition-colors"
          >
            <RiUserAddLine className="text-7xl m-4" />
            سائح
          </Link>
          {/* Link to Partner SignUp */}
          <Link
            to="/PartnerSignUpPage" // Change to the path for partner signup
            className="border-2 border-green-100 text-white text-center text-4xl px-8 py-6 mx-4 rounded-md flex flex-col justify-center items-center hover:bg-green-100 hover:text-green-600 transition-colors"
          >
            <FaBuilding className="text-7xl m-4" />
            وكالة
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignUpChoicePage;
